export const DISABLE_POST_COMMENTS_REQUEST = 'post/DISABLE_COMMENTS_REQUEST';
export const DISABLE_POST_COMMENTS_SUCCESS = 'post/DISABLE_COMMENTS_SUCCESS';
export const DISABLE_POST_COMMENTS_FAILURE = 'post/DISABLE_COMMENTS_FAILURE';
